
import { Component, Watch } from 'vue-property-decorator';
import AbpBase from '@/lib/abpbase'
import Util from '@/lib/util';
import header1 from '@/components/headers/vendor-home-header.vue'
import footer1 from '@/components/footers/footer.vue'
import ProductCategory from '@/store/entities/baseInfo/ProductCategory';
import PageRequest from '@/store/entities/page-request';
import ProductList from '@/components/product-list.vue';
import ProductListFilterPanel from '@/components/product-list-filter-panel.vue';

class PageProductRequest extends PageRequest {
  keyword: string;
  tenantId: number;
  from: Date;
  to: Date;
  productCategoryId: number;
  productCategoryNo: string;
  brandId: number;
  productColorId: number;
  vendorNo: string;
}

@Component({
  components: { header1, footer1, ProductList, ProductListFilterPanel }
})
export default class SearchByImage extends AbpBase {
  pagerequest: PageProductRequest = new PageProductRequest();
  parentCategory: ProductCategory = null;
  currentCategory: ProductCategory;

  get list() {
    return this.$store.state.product.list;
  }
  get pageSize() {
    return this.$store.state.product.pageSize;
  }
  get totalCount() {
    return this.$store.state.product.totalCount;
  }
  get currentPage() {
    return this.$store.state.product.currentPage;
  }

  created() {
    this.$store.commit('product/setPageSize', 32);
    Util.setCurrentPageIndex(this);
    this.getpage();
  }

  @Watch('$route')
  routeChange(to: any) {
    this.getpage();
  }

  pageChange(page: number) {
    Util.changePageIndex(this, page);
  }

  handleColorChange(colorId) {
    this.pagerequest.productColorId = colorId;
    this.getpage();
  }

  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    this.pagerequest.vendorNo = this.$route.query.vid.toString()

    if (this.$route.query.q) {
      this.pagerequest.keyword = this.$route.query.q.toString();
    }

    if (this.$route.query.ctg) {
      let categoryNo = this.$route.query.ctg.toString();
      let category = Util.getCategory(categoryNo);
      this.pagerequest.productCategoryId = category.id;
      this.pagerequest.productCategoryNo = categoryNo;
      this.currentCategory = category;
      this.parentCategory = category["parentCategory"];
    }

    await this.$store.dispatch({
      type: 'product/getListByVendor',
      data: this.pagerequest,
    });

  }
}
